import { RoleType } from '@dirootie-domain/iam';
import { propOr } from "ramda";
import { IWebSiteRoute } from "./web-site-route";
import { RouteOptions } from "./website-routes.types";
import { sanitizeTextForHeadings, sanitizeTextForPath } from '../../components-fabric';
import { toTitleCase } from '../../packages/core/toolbox/strings/toCases';
import { get } from 'http';

export const createRouteId = <
  TArea extends string,
  TSection extends string,
  TViewType extends string
>(area: TArea, section:TSection, view:TViewType): `${TArea}_${TSection}_${TViewType}` =>`${area}_${section}_${view}`;

export const createRouteIdIndex = <
  TBase extends string,
  TSection extends string>(base:TBase,section:TSection) => createRouteId<TBase,TSection,"index">(base,section,"index");

export const createRouteIdFor = <
  TBase extends string,
  TSection extends string
  >(base:TBase,section:TSection) =>
    <TViewType extends string>(view: TViewType) => createRouteId(base,section,view);

const getRoles = propOr(['STUDY_DIRECTOR','LECTURER','STUDENT'], "roles");
const getProtected = propOr(true,"protected");

export const createRouteFor = <
  TBase extends string,
  TSection extends string
  >(base:TBase,section:TSection) => <
  TViewType extends string>(view: TViewType, routeOptions: RouteOptions):
    {id:`${typeof base}_${typeof section}_${typeof view}`, to: string,label: string, roles: RoleType[], protected: boolean} => ({
    id: createRouteIdFor(base,section)(view),
    label: toTitleCase(sanitizeTextForHeadings(propOr(section.charAt(0).toUpperCase() + section.slice(1),"label")(routeOptions))),
    to: propOr(`${routeOptions.basePath}/${sanitizeTextForPath(section)}`,"to")(routeOptions),
    roles: getRoles(routeOptions),
    protected: getProtected(routeOptions)
  });


export const createDashboardRoute = <
TS extends string
>(section: TS, routeOptions: RouteOptions): {id:`${TS}_dashboard`, to: string,label: string, roles: RoleType[], protected: boolean} => ({
id: `${section}_dashboard` as const,
label: propOr("Dashboard","label")(routeOptions),
to: propOr(`/${section}`,"to")(routeOptions),
roles: propOr(['STUDY_DIRECTOR','LECTURER','STUDENT'], "roles")(routeOptions),
protected: propOr(true,"protected")(routeOptions)
});
